"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionOrderType = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class SubscriptionOrderType {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    getSubscriptionOrderTypeList() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = this.baseUrl + 'pay_per_user/plan/list_purchase_orders_type';
                let response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error(error.response.data.message);
            }
        });
    }
    createSubscriptionOrderType(subscriptionOrderTypeData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = this.baseUrl + 'pay_per_user/plan/admin/create_purchase_orders_type';
                let response = yield axios_1.default.post(url, subscriptionOrderTypeData, {
                    headers: header,
                });
                const responseData = response.data.message;
                return responseData;
            }
            catch (error) {
                throw new Error(error.response.data.message);
            }
        });
    }
}
exports.SubscriptionOrderType = SubscriptionOrderType;
